/**
 * OurLatestPost Widget
 */
import React , {Component} from 'react';
import Slider from "react-slick";
import { Row, Col, Container } from 'reactstrap';
import {Link} from 'react-router-dom';


function OurLatestPost(props) {

    const settings = props.settings;
    return (
            <Col sm={12}>
                <div className="latest-post-wrapper latest-post-type-carousel latest-post-style-1 latest-post-without-intro">
                    <Slider {...settings} className="slider-arrow-hover slider-spacing-10">
                        <div className="item">
                            <div className="latest-post-item">
                                <div className="latest-post-item-inner">
                                <div className="latest-post-image">
                                    <img  src={require(`../assets/images/blog/img-01.jpg`)}  className="img-fluid" alt="blog" />
                                </div>
                                <div className="latest-post-content">
                                    <div className="post-date">
                                    <div className="post-date-inner">
                                    14<span>Aug</span>
                                    </div>
                                    </div>
                                    <div className="latest-post-meta">
                                    <ul>
                                    <li>
                                        <i className="fa fa-user" />
                                        <Link to="#" rel="category tag">athletico</Link>
                                    </li>
                                    <li>
                                        <i className="fa fa-folder-open" />
                                        <Link to="#" rel="category tag">Styling</Link>
                                    </li>
                                    </ul>
                                    </div>
                                    <h3 className="blog-title">
                                    <Link to="#">Styling 101: Athleisure Leggings</Link>
                                    </h3>
                                    <div className="latest-post-excerpt">
                                    <p>Leggings have been around for a long time and it’s been a constant question of whether it’s acceptable to be worn as pants....</p>
                                    </div>
                                    <div className="latest-post-entry-footer">
                                    <Link to="#">Read More...</Link>
                                    <div className="latest-post-social-share">
                                    <ul>
                                        <li>
                                            <Link to="#" className="facebook-share">
                                            <i className="fa fa-facebook" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="twitter-share">
                                            <i className="fa fa-twitter" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="linkedin-share">
                                            <i className="fa fa-linkedin" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="google-share">
                                            <i className="fa fa-google" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="pinterest-share">
                                            <i className="fa fa-pinterest" />
                                            </Link>
                                        </li>
                                    </ul>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="latest-post-item">
                                <div className="latest-post-item-inner">
                                <div className="latest-post-image">
                                    <img src={require(`../assets/images/blog/img-02.jpg`)} className="img-fluid" alt="blog" />
                                </div>
                                <div className="latest-post-content">
                                    <div className="post-date">
                                    <div className="post-date-inner">
                                    24<span>Aug</span>
                                    </div>
                                    </div>
                                    <div className="latest-post-meta">
                                    <ul>
                                    <li>
                                        <i className="fa fa-user" />
                                        <Link to="#" rel="category tag">athletico</Link>
                                    </li>
                                    <li>
                                        <i className="fa fa-folder-open" />
                                        <Link to="#" rel="category tag">Fashion</Link>
                                    </li>
                                    </ul>
                                    </div>
                                    <h3 className="blog-title">
                                    <Link to="#">What is Fitwear?</Link>
                                    </h3>
                                    <div className="latest-post-excerpt">
                                    <p>Fitwear is the clothing you use when you are working out and doing sports. These are designed to be functional and comfortable for people doing fitness. ...</p>
                                    </div>
                                    <div className="latest-post-entry-footer">
                                    <Link to="#">Read More...</Link>
                                    <div className="latest-post-social-share">
                                    <ul>
                                        <li>
                                            <Link to="#" className="facebook-share">
                                            <i className="fa fa-facebook" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="twitter-share">
                                            <i className="fa fa-twitter" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="linkedin-share">
                                            <i className="fa fa-linkedin" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="google-share">
                                            <i className="fa fa-google" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="pinterest-share">
                                            <i className="fa fa-pinterest" />
                                            </Link>
                                        </li>
                                    </ul>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="latest-post-item">
                                <div className="latest-post-item-inner">
                                <div className="latest-post-image">
                                    <img  src={require(`../assets/images/blog/img-03.jpg`)}  className="img-fluid" alt="blog" />
                                </div>
                                <div className="latest-post-content">
                                    <div className="post-date">
                                    <div className="post-date-inner">
                                    15<span>Oct</span>
                                    </div>
                                    </div>
                                    <div className="latest-post-meta">
                                    <ul>
                                    <li>
                                        <i className="fa fa-user" />
                                        <Link to="#" rel="category tag">athletico</Link>
                                    </li>
                                    <li>
                                        <i className="fa fa-folder-open" />
                                        <Link to="#" rel="category tag">Style</Link>
                                    </li>
                                    </ul>
                                    </div>
                                    <h3 className="blog-title">
                                    <Link to="#">How to style athleisure clothing</Link>
                                    </h3>
                                    <div className="latest-post-excerpt">
                                    <p>With people getting more and more busy, we strive to look for comfort in every aspect includes our clothing. At the same time, we still want to look stylish and put together so how does this happen? Athleisure clothing is the answer. ...</p>
                                    </div>
                                    <div className="latest-post-entry-footer">
                                    <Link to="#">Read More...</Link>
                                    <div className="latest-post-social-share">
                                    <ul>
                                        <li>
                                            <Link to="#" className="facebook-share">
                                            <i className="fa fa-facebook" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="twitter-share">
                                            <i className="fa fa-twitter" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="linkedin-share">
                                            <i className="fa fa-linkedin" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="google-share">
                                            <i className="fa fa-google" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="pinterest-share">
                                            <i className="fa fa-pinterest" />
                                            </Link>
                                        </li>
                                    </ul>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="latest-post-item">
                                <div className="latest-post-item-inner">
                                <div className="latest-post-image">
                                    <img  src={require(`../assets/images/blog/img-04.jpg`)}  className="img-fluid" alt="blog" />
                                </div>
                                <div className="latest-post-content">
                                    <div className="post-date">
                                    <div className="post-date-inner">
                                    18<span>Sep</span>
                                    </div>
                                    </div>
                                    <div className="latest-post-meta">
                                    <ul>
                                    <li>
                                        <i className="fa fa-user" />
                                        <Link to="#" rel="category tag">athletico</Link>
                                    </li>
                                    <li>
                                        <i className="fa fa-folder-open" />
                                        <Link to="#" rel="category tag">Fitness</Link>
                                    </li>
                                    </ul>
                                    </div>
                                    <h3 className="blog-title">
                                    <Link to="#">What is Fitwear?</Link>
                                    </h3>
                                    <div className="latest-post-excerpt">
                                    <p>So, there you have it; the six steps that will help you to the fabled land...</p>
                                    </div>
                                    <div className="latest-post-entry-footer">
                                    <Link to="#">Read More...</Link>
                                    <div className="latest-post-social-share">
                                    <ul>
                                        <li>
                                            <Link to="#" className="facebook-share">
                                            <i className="fa fa-facebook" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="twitter-share">
                                            <i className="fa fa-twitter" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="linkedin-share">
                                            <i className="fa fa-linkedin" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="google-share">
                                            <i className="fa fa-google" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="pinterest-share">
                                            <i className="fa fa-pinterest" />
                                            </Link>
                                        </li>
                                    </ul>
                                    </div>
                                    </div>
                                </div>
                                </div>
                                </div>
                            </div>
                    </Slider>
                </div>
            </Col>
      )

}

export default OurLatestPost;

